import { render, staticRenderFns } from "./CustomerIndex.vue?vue&type=template&id=1631300e&"
import script from "./CustomerIndex.vue?vue&type=script&lang=js&"
export * from "./CustomerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports